import { IPagination } from "../../components/IPagination";
import { IFilter, IModalFilterOptions } from "../interfaces/IFilterDataContext";

export const initialFilter: IFilter = {
    campus: {
        list: [],
        selectedValue: [],
    },
    school: {
        list: [],
        selectedValue: [],
    },
    modality: {
        list: [],
        selectedValue: [],
    },
    course: {
        list: [],
        selectedValue: [],
    },
    professor: {
        list: [],
        selectedValue: [],
    },
    effectiveDate: {
        initialDate: undefined,
        finalDate: undefined,
    },
    status: "",
    pagination: {
        actualPage: 0,
        sizePage: 0,
        totalPages: 0,
        totalRecords: 0,
    },
    openModal: false,
};

export const initialModalFilterOptions: IModalFilterOptions = {
    key: "",
    tempSelectedValue: [],
};

export const initialPagination: IPagination = {
    actualPage: 1,
    sizePage: 5,
    totalPages: 0,
    totalRecords: 0,
};
